/** Valid cash register cut types */
export const CASH_REGISTER_TYPES = {
  BLIND: 'blind',
  VISIBLE: 'visible',
} as const;

export type CashRegisterTypeValue = typeof CASH_REGISTER_TYPES[keyof typeof CASH_REGISTER_TYPES];

/** Cash register configuration value object — cut type */
export type CashRegisterConfig = Readonly<{
  cutType: CashRegisterTypeValue;
}>;

const VALID_TYPES = new Set<string>(Object.values(CASH_REGISTER_TYPES));

/**
 * Creates a validated CashRegisterConfig value object.
 *
 * @param cutType - Cash register cut type ('blind' or 'visible')
 * @returns Frozen CashRegisterConfig
 * @throws Error if cutType is not a valid option
 */
export const createCashRegisterConfig = (cutType: string): CashRegisterConfig => {
  if (!VALID_TYPES.has(cutType)) {
    throw new Error(`Invalid cash register type: ${cutType}. Must be one of: ${[...VALID_TYPES].join(', ')}`);
  }
  return Object.freeze({ cutType: cutType as CashRegisterTypeValue });
};
